<template>
<div class="chapter">
<div class="inner_page">
<a id="pageii">
<p class="ded">‘We have had a most bloody battle with the French; yesterday we began at five in the morning and left off at two in the afternoon, all which time the French kept cannonading us; I was forced to be very civil and make a great many bows to the balls for they were very near me. The foot were very sadly cut to pieces, for the French put grapeshot into their cannon and cut them down just as if they were shearing corn.’</p>
<p class="right">Wilson, A., <em class="italic">The Story of the Guns</em>, 1944, p. 29.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?026e1443